import * as React from "react";

interface ClampTextProps {
  /** The text (or node) to display, truncated after `lines`. */
  text?: React.ReactNode;
  /** Max width before truncating — number (px) or any CSS width. Default 200. */
  width?: number | string;
  /** Number of lines to show before the ellipsis. Default 2. */
  lines?: number;
  /** Optional class (e.g. "ctpl-tmpl-name" to keep bold styling). */
  className?: string;
  /** Tooltip text; falls back to `text` when it's a string. */
  title?: string;
}

/**
 * Truncates long cell content to `lines` with an ellipsis and shows the full
 * value on hover. Keeps table rows a consistent, compact height.
 */
export default function ClampText({
  text,
  width = 200,
  lines = 2,
  className,
  title,
}: ClampTextProps) {
  return (
    <div
      className={className}
      title={title ?? (typeof text === "string" ? text : undefined)}
      style={{
        maxWidth: width,
        display: "-webkit-box",
        WebkitLineClamp: lines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineHeight: 1.4,
        whiteSpace: "normal",
        wordBreak: "break-word",
      }}
    >
      {text}
    </div>
  );
}